import React, {Component} from 'react';
import {connect} from 'react-redux';
import {cloneDeep} from 'lodash';
import {Card, Form, Grid, Message, Button, Input} from 'semantic-ui-react';
import {hasAccessPermission} from '../../common/permissions/validations';
import {resources, scopes} from '../../common/permissions/dictionary';
import {paths} from '../../common/dictionaries/urls';
import {Actions} from '../../common/actions';
import ReplacementSection from '../../partsMaster/components/info/replacementInfo';
import './partQuotation.scss';

class partQuotation extends Component {
  constructor(props) {
    super(props);
    this.state = {'partNoFilter': ''};
    this.handleQuoteClick = this.handleQuoteClick.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PartQuotation,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.clearPriceFactorAndFob();
    this.props.clearReplacementSectionPartQuotes();
  }

  handleQuoteClick() {
    const {partNoFilter} = this.state;

    this.props.getPriceFactorAndFobByPartNo(partNoFilter);
    this.props.getPartEquivalences(partNoFilter);
    this.props.getPartSubstitutes(partNoFilter);
    this.props.getPartSpecialSubstitutes(partNoFilter);
  }

  handleInputChange(event) {
    const stateCopy = cloneDeep(this.state);
    stateCopy.partNoFilter = event.target.value.toUpperCase();
    this.setState(stateCopy);
  }

  renderMessage() {
    const {errorMessage} = this.props;

    if (!errorMessage) {
      return null;
    }

    return <Message negative content={errorMessage} />;
  }

  renderPageHeader() {
    const {partNoFilter} = this.state;
    const {loading} = this.props;

    return (
      <Card raised fluid className='quotation-header'>
        <Grid>
          <Grid.Row>
            <Grid.Column width={16} textAlign='left'>
              <h2>Cotizador de Repuestos</h2>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className='query-section'>
            <Grid.Column width={6} textAlign='left'>
              <label>
                <strong>Código:</strong>
              </label>
              <Input
                fluid
                onChange={this.handleInputChange}
                maxLength={20}
                value={partNoFilter}
              />
            </Grid.Column>
            <Grid.Column width={10} textAlign='right' verticalAlign='bottom'>
              <Button
                primary
                onClick={this.handleQuoteClick}
                disabled={loading || !partNoFilter}
              >
                Cotizar
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    );
  }

  renderValues() {
    const {regularPrice, greyPrice, description, stockTmc, productionTime, difFactor} = this.props;

    return (
      <Card raised fluid className='values-body'>
        <Form>
          <Form.Group widths='equal'>
            <Form.Field>
              <label>Descripción:</label>
              <p>{description}</p>
            </Form.Field>
            <Form.Field>
              <label>Factor Diferenciado:</label>
              <p>{difFactor}</p>
            </Form.Field>
            <Form.Field>
              <label>Precio Sugerido:</label>
              <p>{regularPrice}</p>
            </Form.Field>
            <Form.Field>
              <label>Precio Sugerido (Factor Gris):</label>
              <p>{greyPrice}</p>
            </Form.Field>
            <Form.Field>
              <label>Stock TMC:</label>
              <p>{stockTmc}</p>
            </Form.Field>
            <Form.Field>
              <label>Tiempo Producción:</label>
              <p>{productionTime}</p>
            </Form.Field>
          </Form.Group>
        </Form>
        <ReplacementSection readOnly />
      </Card>
    );
  }

  render() {
    return (
      <div className='part-quotation'>
        {this.renderPageHeader()}
        {this.renderMessage()}
        {this.renderValues()}
        <Message info>
          <Message.Header>NOTAS:</Message.Header>
          <Message.List>
            <Message.Item>Los precios no incluyen IVA.</Message.Item>
            <Message.Item>
              Los valores son referenciales y están sujetos a cambios en base a
              la disponiblidad en la fuente.
            </Message.Item>
          </Message.List>
        </Message>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.partQuotation.loading,
    'regularPrice': state.partQuotation.regularPrice,
    'greyPrice': state.partQuotation.greyPrice,
    'leadTime': state.partQuotation.leadTime,
    'description': state.partQuotation.description,
    'permissions': state.session.permissions,
    'errorMessage': state.partQuotation.errorMessage,
    'stockTmc': state.partQuotation.stockTmc,
    'productionTime': state.partQuotation.productionTime,
    'difFactor': state.partQuotation.difFactor,
  };
};

const {
  getPriceFactorAndFobByPartNo,
  clearPriceFactorAndFob,
  getPartSubstitutes,
  getPartEquivalences,
  getPartSpecialSubstitutes,
  clearReplacementSectionPartQuotes,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  getPriceFactorAndFobByPartNo,
  clearPriceFactorAndFob,
  getPartSubstitutes,
  getPartEquivalences,
  getPartSpecialSubstitutes,
  clearReplacementSectionPartQuotes,
  navigateTo,
})(partQuotation);
